/** Keep localized words and separators while consistently displaying digits 0–9. */
export function formatLocale(language: string): string {
  return new Intl.Locale(language, { numberingSystem: "latn" }).toString();
}
